module.exports = __webpack_public_path__ + "img/ai.9d577352.svg";